import { apiRequest, getResource, sendForSuccess } from "../api/http";

export function getAllPackage() {
  return getResource("/api/packages/get-all-package", {
    select: (data) => data.package,
    fallback: [],
  });
}

export function addPackage(obj) {
  return sendForSuccess("post", "/api/packages/add-package", obj);
}

export function updatePackage(obj, package_id) {
  return apiRequest("put", `/api/packages/update-package/${package_id}`, {
    data: obj,
  });
}

/**
 * Monthly and annual plans with the prices they give everywhere (card through
 * Stripe, Mobile Money in CFA franc). Rejects on failure.
 */
export function getSubscriptionPlans() {
  return getResource("/api/admin/subscription-plans", { rethrow: true });
}

/**
 * New price (and name, description) of a plan: the API updates Stripe, Mobile
 * Money, the site and the apps. Resolves with the updated plans.
 */
export function updateSubscriptionPlan(type, { price, name, description }) {
  return apiRequest("put", `/api/admin/subscription-plans/${type}`, {
    data: { price: Number(price), name, description },
    rethrow: true,
  });
}
